<script lang="ts">
    import trackingService from '@tile/services/TrackingService.browser';
</script>

<oc-sheet-v1
    id="reptile-ratings-sheet"
    headline="So funktionieren unsere Kundenbewertungen"
    base64-url="L2NoYW1lbGVvbi9jcm9jb3RpbGUvcmF0aW5nX3NoZWV0X3RleHQuaHRtbA=="
    onoc-sheet-open={() => {
        trackingService.trackListLayer('rating');
    }}
></oc-sheet-v1>
<oc-sheet-v1
    id="reptile-ratings-detail-sheet"
    headline="Richtlinien für Bewertungen"
    base64-url="L2NoYW1lbGVvbi9jcm9jb3RpbGUvcmF0aW5nX3NoZWV0X2RldGFpbF90ZXh0Lmh0bWw="
></oc-sheet-v1>
